module.exports = __webpack_public_path__ + "img/patrocinadores_tangamanga.82d90188.png";